import { Component, Input, OnInit } from '@angular/core';

import { parseFrameString } from '../../../../utils/utils';

@Component({
  selector: 'backward-control',
  templateUrl: 'kh-manip-backward.component.html',
  styleUrls: ['kh-manip-backward.component.less'],
  standalone: false
})
export class KhManipulativeBackwardComponent implements OnInit {
  @Input() public key = '';
  @Input() public image = '';
  @Input() public frame = '0 0 100 100';

  public onClick: () => void;
  public box = { left: 0, top: 0, width: 0, height: 0 };

  public ngOnInit() {
    const frame = parseFrameString(this.frame);
    this.box = { left: frame.x, top: frame.y, width: frame.width, height: frame.height };
  }

  public onClickEvent(): void {
    if (this.onClick) {
      this.onClick();
    }
  }
}
